if (!customElements.get('collapsible-tabs')) {
  customElements.define(
    'collapsible-tabs',
    class CollapsibleTabs extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.detailsElements = this.querySelectorAll('.accordion-details');
        this.colorScheme = this.dataset.colorScheme;

        this.detailsElements.length > 0 &&
          this.detailsElements.forEach((details) => {
            details.open ? this.handleOpen(details) : this.handleClose(details);
            details.addEventListener('toggle', this.onToggle.bind(this));
          });
      }

      onToggle(event) {
        const activeDetails = event.target;
        if (activeDetails.open) {
          this.handleOpen(activeDetails);
        } else {
          this.handleClose(activeDetails);
        }
      }

      handleOpen(details) {
        const parent = details.closest('.accordion-item');
        parent.classList.contains('accordion-card') && parent.classList.add(this.colorScheme);
      }

      handleClose(details) {
        const parent = details.closest('.accordion-item');
        parent.classList.contains('accordion-card') && parent.classList.remove(this.colorScheme);
      }
    }
  );

  setTimeout(()=>{
      const el = document.querySelectorAll('.accordion-details__content--locations--map');
      if(el){
          el.forEach((item)=>{
              item.classList.remove('hidden');
          })
      }
  }, 3000)
}

document.addEventListener('DOMContentLoaded', function() {
  const mainAccordionSections = document.querySelectorAll('.main-accordion-item');
  
  if (mainAccordionSections.length > 1) {
    mainAccordionSections.forEach(section => {
      const firstLevelDetails = section.querySelector(':scope > .accordion-details');
      
      if (firstLevelDetails) {
        firstLevelDetails.addEventListener('toggle', function(event) {
          const openedDetails = event.target;
          
          if (openedDetails === firstLevelDetails && openedDetails.open) {
            mainAccordionSections.forEach(otherSection => {
              if (otherSection !== section) {
                const otherFirstLevel = otherSection.querySelector(':scope > .accordion-details');
                if (otherFirstLevel && otherFirstLevel.open) {
                  otherFirstLevel.open = false;
                }
              }
            });
          }
        });
      }
    });
  }
});


